(() => {
  if (window.NavelisQuickAdd) return;
  window.NavelisQuickAdd = true;

  // History restoration must not preserve a stale pointer-hover action.
  const resetCardHover = () => {
    document.querySelectorAll('.product-card').forEach(card => {
      card.setAttribute('data-return-reset', '');
    });
  };
  window.addEventListener('pagehide', resetCardHover);
  window.addEventListener('pageshow', event => {
    if (event.persisted) resetCardHover();
  });
  document.addEventListener('pointermove', event => {
    if (event.pointerType === 'touch') return;
    event.target.closest('.product-card[data-return-reset]')?.removeAttribute('data-return-reset');
  }, { passive: true });
  document.addEventListener('pointerout', event => {
    const card = event.target.closest('.product-card[data-return-reset]');
    if (card && !card.contains(event.relatedTarget)) card.removeAttribute('data-return-reset');
  }, { passive: true });

  const updateCartCount = (itemCount) => {
    document.querySelectorAll('.site-header__cart').forEach((cartLink) => {
      let count = cartLink.querySelector('.site-header__cart-count');

      if (!count && itemCount > 0) {
        count = document.createElement('span');
        count.className = 'site-header__cart-count';
        cartLink.append(count);
      }

      if (count) {
        count.textContent = itemCount;
        count.hidden = itemCount < 1;
      }
    });
  };

  document.addEventListener('change', (event) => {
    const select = event.target.closest('.product-card__variant');
    if (!select) return;
    const button = select.form?.querySelector('[data-quick-add-button]');
    const option = select.selectedOptions[0];
    if (!button || !option) return;
    const quantity = select.form.querySelector('[name="quantity"]');
    if (quantity && window.TemporiQuantityRules) {
      Object.assign(quantity.dataset, { ruleMin: option.dataset.ruleMin, ruleIncrement: option.dataset.ruleIncrement, ruleMax: option.dataset.ruleMax, variantId: option.value });
      if (quantity.type !== 'hidden') quantity.setAttribute('data-quantity-rule-input', '');
      const bounds = window.TemporiQuantityRules.apply(quantity, Number(option.dataset.cartQuantity));
      quantity.value = bounds.allowed ? bounds.minimum : 0;
    }
    button.textContent = option.dataset.preorder === 'true' ? button.dataset.preorderLabel : button.dataset.addLabel;
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[data-quick-add-form]');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('[data-quick-add-button]');
    const status = form.querySelector('[data-quick-add-status]');
    if (!button || button.dataset.loading === 'true') return;

    const originalLabel = button.textContent.trim();
    button.dataset.loading = 'true';
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');

    try {
      const quantity = form.querySelector('[name="quantity"]');
      if (quantity && quantity.type !== 'hidden' && window.TemporiQuantityRules) {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error(button.dataset.quantityError);
        const cart = await response.json();
        const id = new FormData(form).get('id');
        const count = cart.items.filter(item => String(item.variant_id) === String(id)).reduce((sum, item) => sum + Number(item.quantity), 0);
        window.TemporiQuantityRules.apply(quantity, count);
        if (!window.TemporiQuantityRules.valid(Number(quantity.value), window.TemporiQuantityRules.ruleFor(quantity), count)) {
          quantity.focus();
          throw new Error(button.dataset.quantityError);
        }
      }
      if (window.NavelisCart) {
        await window.NavelisCart.add(new FormData(form), button);
        button.textContent = button.dataset.addedLabel;
        if (status) status.textContent = button.dataset.addedLabel;
        return;
      }

      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest',
        },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error('Unable to add product');

      const cartResponse = await fetch(`${root}cart.js`, {
        headers: { Accept: 'application/json' },
      });
      const cart = await cartResponse.json();

      updateCartCount(cart.item_count);
      button.textContent = button.dataset.addedLabel;
      if (status) status.textContent = button.dataset.addedLabel;
      document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart } }));
    } catch (error) {
      button.textContent = button.dataset.errorLabel;
      if (status) status.textContent = error.message === button.dataset.quantityError ? button.dataset.quantityError : button.dataset.errorLabel;
    } finally {
      window.setTimeout(() => {
        const selectedOption = form.querySelector('.product-card__variant')?.selectedOptions[0];
        button.textContent = selectedOption
          ? (selectedOption.dataset.preorder === 'true' ? button.dataset.preorderLabel : button.dataset.addLabel)
          : originalLabel;
        button.disabled = false;
        button.removeAttribute('aria-busy');
        delete button.dataset.loading;
        if (status) status.textContent = '';
      }, 1600);
    }
  });
})();
